import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteKyc,
  getAllKyc,
  updateKycStatus,
} from "../../redux/services/kycSlice";
import { CgEye } from "react-icons/cg";
import { convertUtcToIstDateOnly } from "../../common/TimeUtils";
import Table from "../../common/Table";
import Model from "../../common/Model";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import { onExportkycDetails } from "../../common/PdfFormat";

const KYC = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const [filter, setFilter] = useState("");
  const [details, setDetails] = useState();
  const [modelOpen, setModelOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [page, setPage] = useState(0);
  const getKycData = useSelector((state) => state.kyc.kycData);
  const [statusMap, setStatusMap] = useState({});
  const getAllKycApi = React.useCallback(async () => {
    try {
      await dispatch(
        getAllKyc({ page: page + 1, limit: pageLimit, filter, searchData })
      );
    } catch (error) { }
  }, [dispatch, page, pageLimit, filter, searchData]);

  useEffect(() => {
    getAllKycApi();
  }, [getAllKycApi]);
  const deleteKycData = async () => {
    try {
      const response = await dispatch(deleteKyc(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllKycApi();
    } catch (error) { }
  };
  const handleStatusChange = async (id, status) => {
    setStatusMap((prev) => ({ ...prev, [id]: status }));
    let payload = {
      kycId: id,
      status: status,
    };
    try {
      let response = await dispatch(updateKycStatus(payload));
      if (response) {
        getAllKycApi();
      }
    } catch (error) { }
  };
  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    {
      header: "Name",
      key: "userName",
      render: (_, row) => {
        if (!row?.user) {
          return "-";
        }
        return `${row?.user?.firstName + " " + row?.user?.lastName}`;
      },
    },
    {
      header: "Ph No.",
      key: "contact",
      render: (_, row) =>
        row?.user?.contact?.mobile
          ? `${row?.user?.contact?.countryCode} ${row?.user?.contact?.mobile}`
          : "-",
    },
    {
      header: "Proof Type",
      key: "proof-type",
      render: (_, row) => row?.idProof || "-",
    },
    {
      header: "Proof Number",
      key: "proof-number",
      render: (_, row) => row?.idNumber || "-",
    },
    {
      header: "Email",
      key: "email",
      render: (_, row) => row?.user?.email || "-",
    },
    {
      header: "Status",
      key: "status",
      render: (_, row) => (
        <select
          value={statusMap[row._id] || row.status || "Pending"}
          onChange={(e) => handleStatusChange(row._id, e.target.value)}
          className={`border rounded-xl p-2 outline-none cursor-pointer
                      ${statusMap[row._id] === "verified" ||
              row.status === "verified"
              ? "bg-green-100 text-green-700"
              : ""
            }
                      ${statusMap[row._id] === "pending" ||
              row.status === "pending"
              ? "bg-yellow-100 text-yellow-700"
              : ""
            }
                      ${statusMap[row._id] === "unverified" ||
              row.status === "unverified"
              ? "bg-red-100 text-red-700"
              : ""
            }
                    `}
        >
          <option value="verified" className="bg-card text-black">
            Verified
          </option>
          <option value="pending" className="bg-card text-black">
            Pending
          </option>
          <option value="unverified" className="bg-card text-black">
            Unverified
          </option>
        </select>
      ),
    },
  ];
  const actions = [
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
    {
      icon: <CgEye className="w-5 h-5" />,
      onClick: (row) => {
        setModelOpen(true);
        setDetails(row);
      },
    },
  ];
  const filterOptions = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "verified", label: "Verified" },
    { value: "unverified", label: "Unverified" },
  ];

  const KycData = [
    {
      label: "Name",
      value: details?.user?.firstName + " " + details?.user?.lastName,
      condition: details?.user,
    },
    {
      label: "Ph No",
      value: details?.user
        ? details?.user?.contact?.countryCode +
        " " +
        details?.user?.contact?.mobile
        : "-",
      condition: details?.user?.email,
    },
    {
      label: "DOB",
      value: convertUtcToIstDateOnly(details?.user?.dob),
      condition: details?.user?.dob,
    },
    {
      label: "City",
      value: details?.user?.city,
      condition: details?.user?.city,
    },
    {
      label: "Proof Type",
      value: details?.idProof,
      condition: details?.idProof,
    },
    {
      label: "Proof Number",
      value: details?.idNumber,
      condition: details?.idNumber,
    },
  ];

  const exportToPDF = () => {
    const kycData = getKycData?.kyc_data || [];
    if (kycData?.length > 0) {
      onExportkycDetails(kycData);
    } else {
    }
  };
  return (
    <>
      <Table
        title="KYC"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        columns={columns}
        data={getKycData?.kyc_data}
        actions={actions}
        pageCount={getKycData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        filterOptions={filterOptions}
        selectedFilter={filter}
        onFilterChange={(e) => setFilter(e ? e.value : "")}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
        exportButton={true}
        onExport={exportToPDF}
      />
      {confirm && (
        <ConfirmationPage
          topicName="Kyc"
          confirm={confirm}
          onDelete={deleteKycData}
          onCancel={() => setConfirm(false)}
        />
      )}
      {modelOpen && (
        <Model closeModal={() => setModelOpen(false)} title="KYC Details">
          <div className="grid md:grid-cols-2 gap-4">
            {KycData.filter((item) => item.condition).map((item, index) => (
              <h3 key={index} className="mb-0">
                <span className="font-bold">{item.label} :</span> {item.value}
              </h3>
            ))}
          </div>

          {(details?.frontSideImage || details?.backSideImage) && (
            <div className="mt-5">
              <span className="font-bold">Proof Image: </span>
              <div className="grid md:grid-cols-2 grid-cols-1 gap-4 mt-2 w-full">
                {details?.frontSideImage &&
                  details.frontSideImage.trim() !== "" && (
                    <img
                      src={details.frontSideImage}
                      alt="Front Side"
                      className="w-full h-36 border border-border rounded-xl"
                    />
                  )}
                {details?.backSideImage &&
                  details.backSideImage.trim() !== "" && (
                    <img
                      src={details.backSideImage}
                      alt="Back Side"
                      className="w-full h-36 border border-border rounded-xl"
                    />
                  )}
              </div>
            </div>
          )}
        </Model>
      )}
    </>
  );
};

export default KYC;
